import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import { useState, useEffect, useRef, useMemo } from 'react';
import '../index.scss';

const ImgPreview = observer<{
  list: any[];
  huhandleAdd: () => void;
  huhandleDelete: (index) => void;
}>(({ list, huhandleAdd, huhandleDelete }) => {
  const [currentId, setCurrentId] = useState('');
  const prevListLengthRef = useRef(0);
  const prevSelectedIndexRef = useRef(-1);

  // 获取当前显示的图片索引和URL
  const { currentIndex, currentImgUrl } = useMemo(() => {
    const index = list.findIndex(item => item.id === currentId);
    return {
      currentIndex: index,
      currentImgUrl: index >= 0 ? list[index]?.url : list[0]?.url,
    };
  }, [list, currentId]);

  // 处理列表变化和选中项逻辑
  useEffect(() => {
    if (list.length === 0) return;

    // 初始化：如果没有选中项但列表有内容，选中第一项
    if (!currentId && list.length > 0) {
      setCurrentId(list[0].id);
      prevListLengthRef.current = list.length;
      prevSelectedIndexRef.current = 0;
      return;
    }

    // 新增图片：选中最后一项
    if (list.length > prevListLengthRef.current) {
      const lastItem = list[list.length - 1];
      if (lastItem?.id) {
        setCurrentId(lastItem.id);
      }
    }
    // 删除图片：如果删除的是当前选中项，则选中前一项
    else if (list.length < prevListLengthRef.current && currentIndex === -1) {
      const prevIndex = Math.max(0, prevSelectedIndexRef.current - 1);
      if (list[prevIndex]) {
        setCurrentId(list[prevIndex].id);
      } else if (list[0]) {
        setCurrentId(list[0].id);
      }
    }

    // 更新引用值
    prevListLengthRef.current = list.length;
    prevSelectedIndexRef.current = currentIndex;
  }, [list, currentId, currentIndex]);

  // 处理删除操作
  const handleDelete = (index, e) => {
    e.stopPropagation();
    prevSelectedIndexRef.current = currentIndex;
    huhandleDelete(index);
  };

  return (
    <div className="flex flex-col h-full gap-20px bg-[#F7F8FC]">
      <div className="flex h-full items-center rounded-20px justify-center overflow-hidden bg-[#fff] border-1px border-[#1d21291a]">
        {currentImgUrl && (
          <img
            className="object-contain animate-work-flush max-w-full max-h-full h-full"
            src={currentImgUrl}
            alt=""
          />
        )}
      </div>
      <ul className="px-4px flex items-center gap-2 mb-4px">
        {list?.map((img, i) => (
          <li
            key={img.id || i}
            className={`aigc-selector-border thumbs-li aspect-square group relative cursor-pointer !before:-inset-2px transition-colors duration-300 list-none flex gap-12px items-center ${img.id === currentId && 'is-active'}`}
            onClick={() => setCurrentId(img.id)}
          >
            <div
              className="relative size-full overflow-hidden rounded-8px"
              style={{
                border: '2px solid transparent',
              }}
            >
              {list.length > 1 && (
                <div
                  className="delete-icon absolute right-[0px] top-[0px] w-16px h-16px rounded-bl-8px"
                  onClick={e => handleDelete(i, e)}
                >
                  <SVGPureIcon
                    name="close-12"
                    size="6"
                    className="absolute left-5px top-5px text-[#fff]"
                  />
                </div>
              )}
              <img
                src={img?.url}
                alt=""
                className="w-[68px] h-[68px] object-cover rounded-md"
                loading="lazy"
              />
            </div>
          </li>
        ))}
        {list.length < 7 && (
          <li
            className="add-icon flex items-center rounded-8px border-1px border-dashed border-[#1d21294d] justify-center w-[68px] h-[68px] cursor-pointer"
            onClick={huhandleAdd}
          >
            <SVGPureIcon name="add-img" size="24" />
          </li>
        )}
      </ul>
    </div>
  );
});

export default ImgPreview;
